export default {"src":"/_next/static/media/sellingFast.6838a04a.svg","height":11,"width":9};